import type { PropertyFn, RGBColor } from "./interpolation";

export interface ParticleConfig {
	ttl: number;
	position: PropertyFn<{ x: number; y: number }>;
	size: PropertyFn<number>;
	opacity: PropertyFn<number>;
	color: PropertyFn<RGBColor>;
	rotation: PropertyFn<number>;
}

export class Particle {
	elapsed: number = 0;
	readonly ttl: number;
	readonly originX: number;
	readonly originY: number;
	readonly positionFn: PropertyFn<{ x: number; y: number }>;
	readonly sizeFn: PropertyFn<number>;
	readonly opacityFn: PropertyFn<number>;
	readonly colorFn: PropertyFn<RGBColor>;
	readonly rotationFn: PropertyFn<number>;

	constructor(originX: number, originY: number, config: ParticleConfig) {
		this.originX = originX;
		this.originY = originY;
		this.ttl = config.ttl;
		this.positionFn = config.position;
		this.sizeFn = config.size;
		this.opacityFn = config.opacity;
		this.colorFn = config.color;
		this.rotationFn = config.rotation;
	}

	isExpired(): boolean {
		return this.elapsed >= this.ttl;
	}
}
